import React from "react"
import { Link } from "gatsby"
import headerStyle from "./header.module.scss"
import navLogo from "../../images/logo/logo2.png"

const Header = () => {
  return (
    <header className={headerStyle.headerContainer}>
      <div className={headerStyle.headerHome}>
        <img src={navLogo} className={headerStyle.navLogo} />
        <h4>
          <Link className={headerStyle.title} to="/">
            Melt Cafe & Gelato
          </Link>
        </h4>
      </div>
      <nav className={headerStyle.headerNav}>
        <ul className={headerStyle.navList}>
          <li>
            <Link className={headerStyle.navItem} to="/menu">
              MENU
            </Link>
          </li>
          <li>
            <Link className={headerStyle.navItem} to="/contact">
              CONTACT
            </Link>
          </li>
          <li>
            <a
              className={headerStyle.navItem}
              href="https://www.exploretock.com/meltcafegelatobar"
              target="_blank"
            >
              ORDER NOW
            </a>
          </li>
        </ul>
      </nav>
    </header>
  )
}

export default Header
